import { WarLogStatusesEnum, WarrantyClaimNoteStatusEnum } from 'api-new/generated';
import { EnumOptions } from 'ts-types';
import { fromEnum } from 'utils/enums';
import { splitPascalCase } from 'utils/strings';

export const WarrantyClaimNoteStatusValues: EnumOptions<typeof WarrantyClaimNoteStatusEnum, string>[] = fromEnum(
  WarrantyClaimNoteStatusEnum,
  ([label, value]: [keyof typeof WarrantyClaimNoteStatusEnum, WarrantyClaimNoteStatusEnum]) => ({
    label: splitPascalCase(label),
    value
  })
);

export const WarLogStatusesEnumLabels: Record<WarLogStatusesEnum, string> = {
  [WarLogStatusesEnum.CorrectionRequired]: 'Correction Required',
  [WarLogStatusesEnum.InvoicedAndSubmitted]: 'Invoiced & Submitted',
  [WarLogStatusesEnum.Pending]: 'Pending',
  [WarLogStatusesEnum.WorkNotCompleted]: 'Work not completed',
  [WarLogStatusesEnum.ATPPending]: 'ATP pending',
  [WarLogStatusesEnum.ReadyToWork]: 'Ready To Work',
  [WarLogStatusesEnum.Rejected]: 'Rejected'
};

export const WarLogStatusesEnumLabelsValues: EnumOptions<typeof WarrantyClaimNoteStatusEnum, string>[] = (
  Object.values(WarrantyClaimNoteStatusEnum).filter(
    (v): v is WarrantyClaimNoteStatusEnum => typeof v === 'number'
  ) as WarrantyClaimNoteStatusEnum[]
).map((value) => ({
  value,
  label: WarLogStatusesEnumLabels[value]
}));
